import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
} from '@/components/common/skeleton';

const TAG_COUNT = 6;

export const TagListSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    {Array.from({ length: TAG_COUNT }).map((_, i) => (
      <View key={i} style={styles.row}>
        <SkeletonBone width={16} height={16} borderRadius={4} />
        <View style={styles.nameWrap}>
          <SkeletonBone width="60%" height={16} />
        </View>
        <SkeletonBone width={36} height={22} borderRadius={11} />
        <SkeletonBone width={16} height={16} borderRadius={4} />
      </View>
    ))}
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 4,
    paddingBottom: 16,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  nameWrap: {
    flex: 1,
  },
});
